import React from 'react';
import apiService from '../services/api';

const AILab = () => {
  return (
    <div style={{ padding: '2rem' }}>
      <h2>AI Exploration Lab</h2>
    </div>
  );
};

export default AILab;
